import { render } from "./IndexCooperationList.vue?vue&type=template&id=5d069e50&scoped=true"
import script from "./IndexCooperationList.vue?vue&type=script&lang=js"
export * from "./IndexCooperationList.vue?vue&type=script&lang=js"

import "./IndexCooperationList.vue?vue&type=style&index=0&id=5d069e50&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d069e50"]])

export default __exports__